import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { award_event_id, awardCategoryActionId, BASE_URL, categoryActionId, responseError, toastError, toastSuccess, user_id, countryActionId, applicationTypeActionId, stateActionId, scoringRoundActionId, applicantTypePricingActionId, juryApplicationStatusActionId } from "../../../utils/constants";
import Header from "../../../common_components/Header";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { juryReviewApplicationList_action, juryApplicationQuery_action, insertUpdateJuryQuery_action, juryReviewScoringPattern_action, insertUpdateJuryReviewScoring_action } from "../../../actions/juryModule_action/jury_dashboard_action";
import { getApplicationFormDefaultDetails_action, getApplicationFormDetails_action } from "../../../actions/applicationModule_action/applicationForm_action";
import { fill_action } from "../../../actions/common_action/fillList_action";
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { Link, Element } from "react-scroll";
import Footer from "../../../common_components/Footer";
import { getAwardQuerywithAnswerComment_action, insertUpdateAwardQuery_action, insertUpdateAwardAnswer_action } from "../../../actions/common_action/awardQuery_action";
import MobileHeader from "../../../common_components/mobileHeader";
import purify from 'dompurify'

const customStyles = {
    control: (provided) => ({
        ...provided,
        borderColor: "#c9c9c9", // Blue border color
        boxShadow: "none",
        "&:hover": {
            borderColor: "#80bdff", // Blue border color on hover
        },
    }),
    multiValue: (provided) => ({
        ...provided,
        borderRadius: "14px",
        padding: "4px",
        backgroundColor: "#00BCD4", // Blue background color for selected value
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: "white", // Text color for selected value
        fontSize: "12px",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: "white",
        "&:hover": {
            backgroundColor: "#00BCD4",
            color: "#fff", // Blue border color on hover
        }, // Remove icon color for selected value
    }),
};

class JuryDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reviewSubmitModal: false, reviewType: null, reviewModalTitle: '', reviewModalContent: '', reviewModalContent2: '',
            isLoading: false, selectedIndex: null, isInstructionsOpen: false, isQueryModal: false,
            user_id: "",
            jury_id: "", application_form_id: '',
            applicantList: [], award_name: '', display_Declaration_file_path: '',
            DeclarationFileName: '',
            StatusID: "",
            isAccordionExpanded: false,
            Event_Name: '',
            category_name: '',
            eligibility_criteria: '',
            screening_process: '',
            categoryFillList: [],
            theme: '',
            important_instructions: '',
            applicationFormList: [],
            DeclarationData: '',
            statusId: 2,
            DeclarationFileName: '',
            DeclarationFileType: '',
            DeclarationFilePath: '',
            application_form_id: '',
            applicant_id: '',
            application_no: '',
            award_event_id: '',
            award_event_profile_id: '',
            declaration_file_path_db: '',
            display_Declaration_file_path: '',
            category_id: '',
            queryCoordinatorData: [], queryLogData: [],
            jury_application_form_query_id: '', qry_ans_by_id: '', qry_answer: '', qry_ans_date: '',
            callback_time: '', callback_date: '', callback_query: '',
            queryData: [], questionQuerydata: [], answerQuerydata: [], commentQuerydata: [], queryPostContent: "",
            isCollapse: false, isReplyMode: false, question_id: '',
            //scoring pattern
            scoringFields: [],
            scoringData: [], highlightField: false,
            application_status_id: '', jury_application_status_id: '',
            sme_certificate_FileName: '', sme_certificate_FileType: '', sme_certificate_FilePath: '', sme_certificate_file_path: null,
            download_SME_Certificate_file_path: '', applicantTypeID: '', countryId: '', stateName: '', cityName: '', pinCode: ''
            , applicantTypeList: [], countryList: [], applicantTypeName: '', category_names: '',
            round_id: '', round_name: '', award_event_profile_id: '', award_name: '', application_status_id: '', status_name: "",
            roundFillList: [], awardProfileFillList: [], applicationStatusFillList: [], application_no: '',
            milestoneEndDate: '', milestoneStartDate: '', juryReviewEndDate: '', juryDateEnded: false,
            //scoring highlighting
            scoringfieldSelected: false, selectedSectionFieldId: '', download_Declaration_file_path: '',
            callbackDate: '', callbackTime: ''
        };
        this.clearFilters = this.clearFilters.bind(this);
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
            setTimeout(() => {
                this.props.navigate("/login");
            }, 500);
        }
        setTimeout(() => {
            {
                sessionStorage.getItem("role_id") == 1 ? (
                    this.props.navigate("/login")
                ) : <></>
            }
        }, 10);
        console.log(this.props.location?.state, 'props')
        const application_status_ids = this.props.location?.state?.application_status_id?.split(",") || [];
        const status_names = this.props.location?.state?.status_name?.split(",") || [];

        const navigateApplicationStatusMultiSelected = application_status_ids.map((id, index) => ({
            value: id.trim(),
            label: status_names[index]?.trim() || ""
        }));

        this.setState({
            award_event_profile_id: this.props.location?.state?.award_event_profile_id,
            award_name: this.props.location?.state?.award_name,
            jury_application_status_id: this.props.location?.state?.application_status_id,
            status_name: this.props.location?.state?.status_name,
            applicationStatusMultiSelected: navigateApplicationStatusMultiSelected
        });

        this.getFillList(categoryActionId, user_id, "", "");
        this.getFillList(countryActionId, user_id, "", "");
        this.getFillList(awardCategoryActionId, user_id, "", award_event_id);
        this.getFillList(applicationTypeActionId, user_id, "", "")
        this.getFillList(scoringRoundActionId, '', '', '')
        this.getFillList(applicantTypePricingActionId, user_id, "", "")
        this.getFillList(juryApplicationStatusActionId, user_id, "", "")
        setTimeout(() => {
            this.getApplicantList();
        }, 500);
    }
    getFillList(value, user_id, keyword, keyvalue) {
        // this.setState({ isLoading: true });
        this.props
            .fill_action(
                value,
                user_id == "" || user_id == null ? null : user_id,
                keyword != "" ? keyword : null,
                keyvalue != "" ? keyvalue : null
            )
            .then((data) => {
                if (data.error != 1) {
                    if (value == categoryActionId) {
                        this.setState({
                            categoryFillList: data.data,
                        });
                    }
                    if (value == awardCategoryActionId) {
                        this.setState({
                            awardProfileFillList: data.data,
                        });
                    }
                    if (value == applicationTypeActionId) {
                        this.setState({
                            applicantTypeList: data.data,
                        });
                    }
                    if (value == stateActionId) {
                        this.setState({
                            stateList: data.data,
                            tempStateList: data.data,
                        })
                    }
                    if (value == countryActionId) {
                        this.setState({ countryList: data.data })
                    }
                    if (value == applicantTypePricingActionId) {
                        if (data.data != '') {
                            this.setState({ isAplicationIsPaid: data.data[0]['price'] != 0 ? true : false })
                        }
                    } if (value == scoringRoundActionId) {
                        this.setState({
                            roundFillList: data.data,
                        });
                    }
                    if (value == juryApplicationStatusActionId) {
                        var tempEventArr = [];
                        for (var i = 0; i < data.data.length; i++) {
                            var eventObj = {};
                            eventObj.label = data.data[i].status_name;
                            eventObj.value = data.data[i].application_status_id;
                            tempEventArr.push(eventObj);
                        }
                        this.setState({
                            applicationStatusFillList: data.data,
                            applicationStatusMultiFillList: tempEventArr,
                        });
                    }
                } else {
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }
    getApplicantList = () => {
        const { round_id, award_event_profile_id, jury_application_status_id } = this.state;
        this.setState({
            isLoading: true, applicantList: [], scoringFields: [], scoringData: [],
            questionQuerydata: [], answerQuerydata: [], commentQuerydata: []
        });
        this.props.juryReviewApplicationList_action(round_id, award_event_profile_id, jury_application_status_id)
            .then((data) => {
                if (data.error !== 1) {
                    this.setState({
                        applicantList: data.data,
                        isLoading: false,
                        currentpage: 1,
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    selectApplicationView(award_event_profile_id, application_form_id, index, jury_application_status_id, juryReviewEndDate) {
        const { award_event_id } = this.state
        const currentDate = new Date();
        const [day, month, year] = juryReviewEndDate.split('-');
        const formattedDate = new Date(`${year}-${month}-${day}`);
        const isJuryDateEnded = formattedDate.setHours(0, 0, 0, 0) <= currentDate.setHours(0, 0, 0, 0);

        this.setState({
            selectedIndex: index,
            award_event_profile_id: award_event_profile_id,
            application_form_id: application_form_id,
            scoringfieldSelected: false,
            selectedSectionFieldId: '',
            scoringFields: [],
            scoringData: [],
            application_status_id: null,
            milestoneStartDate: null,
            milestoneEndDate: null,
            jury_application_status_id: jury_application_status_id,
            juryReviewEndDate: juryReviewEndDate,
            juryDateEnded: isJuryDateEnded
        }, () => {
            this.getApplicationFormDefaultDetails(award_event_profile_id, application_form_id);
            this.getAwardQuerywithAnswerComment(award_event_id, award_event_profile_id, application_form_id);
            this.getJuryReviewScoringPattern(award_event_profile_id, application_form_id);
        });
    }

    selectScoringView(section_fields_id) {
        const { applicationFormList } = this.state
        if (applicationFormList.find((data) => data.award_event_profile_section_fields_id === section_fields_id)) {
            this.setState({ highlightField: true })
        }
    }

    getApplicationFormDefaultDetails(award_event_profile_id, application_form_id) {
        this.setState({ award_event_profile_id: award_event_profile_id, application_form_id: application_form_id })
        this.setState({ isLoading: true })
        this.props.getApplicationFormDefaultDetails_action(award_event_profile_id)
            .then((data) => {
                if (data.error != 1) {
                    if (data.InputFieldData != '' && data.SectionNameData != '') {
                        this.setState({ applicationBlanked: false })
                    } else {
                        this.setState({ applicationBlanked: true })
                    }
                    if (data.application_form_id != '') {
                        this.setState({ application_form_id: data.application_form_id[0]['application_form_id'] })
                    }
                    if (data.InstrunctionData != '') {
                        this.setState({
                            category_id: data.InstrunctionData[0]["category_id"],
                            category_name: data.InstrunctionData[0]["category_name"],
                            category_names: data.InstrunctionData[0]["category_names"],
                            theme: data.InstrunctionData[0]["theme"],
                            eligibility_criteria: data.InstrunctionData[0]["eligibility_criteria"],
                            screening_process: data.InstrunctionData[0]["screening_process"],
                            important_instructions: data.InstrunctionData[0]["important_instructions"],
                            award_event_id: data.InstrunctionData[0]["award_event_id"],
                            award_name: data.InstrunctionData[0]["award_name"],
                            award_event_profile_id: data.InstrunctionData[0]["award_event_profile_id"],
                            DeclarationData: data.InstrunctionData[0]["award_event_profile_declaration"],
                        })
                        const { applicantTypeList } = this.state
                        const applicant_type_ids = data.InstrunctionData[0]["applicant_type_ids"] != null ? data.InstrunctionData[0]["applicant_type_ids"].split(',') : []
                        const finalArray = []
                        applicant_type_ids.length > 0 && applicant_type_ids.map((item) => {
                            for (let i = 0; i < applicantTypeList.length; i++) {
                                if (applicantTypeList[i]['applicant_type_id'] == item) {
                                    finalArray.push(applicantTypeList[i])
                                }
                            }
                        })
                        this.setState({ applicantTypeList: finalArray })
                    }

                    const finalArray = []
                    if (data.SectionNameData != '') {
                        data.SectionNameData.map((item) => {
                            if (data.InputFieldData != '') {
                                const array = []
                                for (let i = 0; i < data.InputFieldData.length; i++) {
                                    data.InputFieldData[i]['applicant_response'] = null
                                    data.InputFieldData[i]['FileName'] = null
                                    data.InputFieldData[i]['FileType'] = null
                                    data.InputFieldData[i]['FilePath'] = null
                                    data.InputFieldData[i]['application_form_id'] = null
                                    data.InputFieldData[i]['application_no'] = null
                                    data.InputFieldData[i]['award_name'] = null
                                    data.InputFieldData[i]['application_status_id'] = 2
                                    if (item.award_event_profile_form_section_id == data.InputFieldData[i]['award_event_profile_form_section_id']) {
                                        if (data.OptionsData != '') {
                                            const optionData = []
                                            for (let j = 0; j < data.OptionsData.length; j++) {
                                                if (data.InputFieldData[i]['award_event_profile_section_fields_id'] == data.OptionsData[j]['award_event_profile_section_fields_id']) {
                                                    if (data.InputFieldData[i]['controltype_Name'] == 'Dropdown - Multi-Select') {
                                                        const obj = {
                                                            label: data.OptionsData[j]['options'],
                                                            value: data.OptionsData[j]['options'],
                                                        }
                                                        optionData.push(obj)
                                                    } else if ((data.InputFieldData[i]['controltype_Name'] == 'Checkbox - Single-Select') || (data.InputFieldData[i]['controltype_Name'] == 'Checkbox - Multi-Select')) {
                                                        data.OptionsData[j]['isChecked'] = false
                                                        optionData.push(data.OptionsData[j])
                                                    } else {
                                                        optionData.push(data.OptionsData[j])
                                                    }
                                                }
                                            }
                                            data.InputFieldData[i]['optionData'] = optionData
                                            array.push(data.InputFieldData[i])
                                        } else {
                                            array.push(data.InputFieldData[i])
                                        }
                                    }
                                }
                                if (array.length > 0) {
                                    array.sort((a, b) => a.seq_no - b.seq_no)
                                    finalArray.push({ section_name: item.section_name, seq_no: item.seq_no, array })
                                }
                            } else {
                                finalArray.push(item)
                            }
                        })
                    }
                    if (finalArray.length > 0) {
                        finalArray.sort((a, b) => a.seq_no - b.seq_no)
                        this.setState({ applicationFormList: finalArray }, () => {
                            this.getApplicationFormDetails(application_form_id)
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }
    getApplicationFormDetails(application_form_id) {
        const { applicationFormList } = this.state
        this.props.getApplicationFormDetails_action(application_form_id)
            .then((data) => {
                if (data.error != 1) {
                    applicationFormList.map((item) => {
                        for (let i = 0; i < item.array.length; i++) {
                            for (let j = 0; j < data.data.length; j++) {
                                if (item.array[i]['award_event_profile_section_fields_id'] == data.data[j]['award_event_profile_section_fields_id']) {
                                    item.array[i]['applicant_response'] = data.data[j]['applicant_response']
                                    item.array[i]['application_form_id'] = data.data[j]['application_form_id']
                                    item.array[i]['application_no'] = data.data[j]['application_no']
                                    item.array[i]['application_status_id'] = data.data[j]['application_status_id']
                                    if (data.data[j]['file_path'] != null) {
                                        item.array[i]['file_path'] = data.data[j]['file_path']
                                        const file = data.data[j]["file_path"].split(`${data.data[j]['application_form_id']}/`)
                                        item.array[i]['FileName'] = file[1]
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Dropdown - Multi-Select') {
                                        const array = item.array[i]['applicant_response'] != null ? item.array[i]['applicant_response'].split(',') : []
                                        const finalArray = []
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (array.includes(item.array[i].optionData[k]['label'])) {
                                                    finalArray.push({
                                                        label: item.array[i].optionData[k]['label'],
                                                        value: item.array[i].optionData[k]['label'],
                                                    })
                                                }
                                            }
                                        }
                                        item.array[i]['Multi_Select_value'] = finalArray
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Checkbox - Single-Select') {
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (item.array[i].optionData[k]['award_event_profile_section_fields_options_id'] == data.data[j]['award_event_profile_section_fields_options_id']) {
                                                    item.array[i].optionData[k]['isChecked'] = true
                                                    item.array[i]['applicant_response'] = item.array[i].optionData[k]['options']
                                                } else {
                                                    item.array[i].optionData[k]['isChecked'] = false
                                                }
                                            }
                                        }
                                    }
                                    if (item.array[i]['controltype_Name'] == 'Checkbox - Multi-Select') {
                                        const array = item.array[i]['applicant_response'] != null ? item.array[i]['applicant_response'].split(' :&: ') : []
                                        if (item.array[i].optionData != undefined) {
                                            for (let k = 0; k < item.array[i].optionData.length; k++) {
                                                if (array.includes(item.array[i].optionData[k]['options'])) {
                                                    item.array[i].optionData[k]['isChecked'] = true
                                                } else {
                                                    item.array[i].optionData[k]['isChecked'] = false
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                    this.setState({ applicationFormList: applicationFormList }, () => {
                        if (data.hdrdata != '') {
                            if (data.hdrdata[0]["declaration_file_path"] != null && data.hdrdata[0]["declaration_file_path"] != '') {
                                const file = data.hdrdata[0]["declaration_file_path"].split(`${data.hdrdata[0]['application_form_id']}/`)
                                const displayFile = data.hdrdata[0]["declaration_file_path"].split('.')
                                this.setState({
                                    DeclarationFileName: file[1],
                                    download_Declaration_file_path: displayFile[1] + '.' + displayFile[2],
                                })
                            }
                            if (data.hdrdata[0]["sme_certificate_file_path"] != null && data.hdrdata[0]["sme_certificate_file_path"] != '') {
                                const file = data.hdrdata[0]["sme_certificate_file_path"].split(`${data.hdrdata[0]['application_form_id']}/`)
                                const displayFile = data.hdrdata[0]["sme_certificate_file_path"].split('.')
                                this.setState({
                                    sme_certificate_FileName: file[1],
                                    download_SME_Certificate_file_path: displayFile[1] + '.' + displayFile[2],
                                })
                            }
                            this.setState({
                                statusId: data.hdrdata[0]['application_status_id'],
                                application_form_id: data.hdrdata[0]['application_form_id'],
                                application_no: data.hdrdata[0]['application_no'],
                                declaration_file_path_db: data.hdrdata[0]["declaration_file_path"],
                                sme_certificate_file_path: data.hdrdata[0]["sme_certificate_file_path"],
                                applicantTypeID: data.hdrdata[0]["applicant_type_id"],
                                applicantTypeName: data.hdrdata[0]["applicant_type"],
                                status_name: data.hdrdata[0]["status_name"],
                                paymentType: data.hdrdata[0]["payment_type"],
                                is_paid: data.hdrdata[0]["is_paid"],
                                is_gst_applicable: data.hdrdata[0]["is_gst_applicable"],
                                cityName: data.hdrdata[0]["city"],
                                stateName: data.hdrdata[0]["state"],
                                countryId: data.hdrdata[0]["country_id"],
                                pinCode: data.hdrdata[0]["pincode"],
                                isIncomplete: data.hdrdata[0]["isIncomplete"],
                                outstanding: data.hdrdata[0]["outstanding"]
                            })
                            if (data.hdrdata[0]["country_id"] == 91) {
                                this.getFillList(stateActionId, '', data.hdrdata[0]["country_id"], '')
                            }
                            this.getFillList(28, this.state.user_id, data.hdrdata[0]["applicant_type_id"], award_event_id);
                        }
                    })
                    this.setState({ isLoading: false })
                }
                else {
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }
    getAwardQuerywithAnswerComment = (award_event_id, award_event_profile_id, application_form_id) => {
        this.setState({ isLoading: true });
        this.props.getAwardQuerywithAnswerComment_action(award_event_id, award_event_profile_id, application_form_id, '')
            .then((data) => {
                if (data.error !== 1) {
                    console.log(award_event_id, award_event_profile_id, application_form_id, '22222222222222222')
                    const questionQuerydata = data.data[0];
                    console.log('questionQuerydata111', questionQuerydata)
                    const answerQuerydata = data.data[1];
                    const queryCoordinatorData = data.data[3];
                    const updatedQuestionQuerydata = questionQuerydata.filter(data => data.query_to == 3||data.role_id==2).map((question) => {
                        const matchingAnswers = answerQuerydata.filter(
                            (answer) => answer.question_id === question.question_id
                        );
                        return { ...question, answerQueryData: matchingAnswers };
                    });
                    this.setState({
                        questionQuerydata: updatedQuestionQuerydata,
                        queryPostContent: '',
                        isLoading: false,
                        queryCoordinatorData: queryCoordinatorData
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    requestCallback() {
        const { queryPostContent, award_event_id, award_event_profile_id, application_form_id, queryDescription, question_id, callbackDate, callbackTime } = this.state;
        const callbackdatetime = callbackDate + ' ' + callbackTime;
        if (callbackDate == '' || callbackDate == null || callbackDate == undefined) {
            toastError('Call Back Date cannot be blank.')
        } if (callbackTime == '' || callbackTime == null || callbackTime == undefined) {
            toastError('Call Back Time cannot be blank.')
        } else {
            const updateQuery = `Requesting a callback on ${moment(callbackDate).format('DD-MM-YYYY')} at ${callbackTime}. ${queryPostContent ? queryPostContent : ''}`;
            this.props.insertUpdateAwardQuery_action(question_id, award_event_id, award_event_profile_id, application_form_id, updateQuery ? updateQuery : queryPostContent, queryDescription, 'callback', callbackdatetime, 3, sessionStorage.getItem('user_name'), sessionStorage.getItem('email_address'))
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ queryDescription: '', queryPostContent: '', rejectRemark: '', queryTo: '', queryModalView: false });
                        setTimeout(() => {
                            this.getAwardQuerywithAnswerComment(award_event_id, award_event_profile_id, application_form_id);
                        }, 200);
                    } else {
                        toastError(data.msg)
                    }
                }).catch((e) => console.log(e))
        }
    }
    postQuery() {
        const { queryPostContent, award_event_id, award_event_profile_id, application_form_id, queryDescription, question_id } = this.state;
        if (queryPostContent == '' || queryPostContent == null || queryPostContent == undefined) {
            toastError('Query cannot be blank.')
        } else {
            this.props.insertUpdateAwardQuery_action(question_id, award_event_id, award_event_profile_id, application_form_id, queryPostContent, queryDescription, 'query', null, 3, sessionStorage.getItem('user_name'), sessionStorage.getItem('email_address'))
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ queryDescription: '', queryPostContent: '', rejectRemark: '', queryTo: '', queryModalView: false });
                        setTimeout(() => {
                            this.getAwardQuerywithAnswerComment(award_event_id, award_event_profile_id, application_form_id);
                        }, 200);
                    } else {
                        toastError(data.msg)
                    }
                }).catch((e) => console.log(e))
        }
    }
    onReplyToggle(question_id) {
        if (this.state.isReplyMode) {
            this.setState({ isReplyMode: false, question_id: null, queryPostContent: '' })
        } else {
            this.setState({ isReplyMode: true, question_id: question_id })
        }
    }
    replyQuery(question_id) {
        const { queryPostContent, answer_id, award_event_profile_id, application_form_id, questionQuerydata } = this.state;
        if (queryPostContent == '') {
            toastError('Kindly Fill Content')
        } else {
            const role_id = sessionStorage.getItem('role_id')
            const queryTo = questionQuerydata.find(item => item.question_id == question_id).role_id
            this.props.insertUpdateAwardAnswer_action(question_id, answer_id, queryPostContent, application_form_id, sessionStorage.getItem('user_name'), sessionStorage.getItem('email_address'), role_id, queryTo)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ queryPostContent: '', isReplyMode: false, question_id: '' }, () => {
                            this.getAwardQuerywithAnswerComment(award_event_id, award_event_profile_id, application_form_id);
                        })
                    } else {
                        toastError(data.msg)
                    }
                }).catch((e) => console.log(e))
        }
    }
    clearFilters() {
        this.setState({
            round_id: "", application_status_id: "", award_event_profile_id: "", applicationStatusMultiSelected: [], status_name: '', jury_application_status_id: ''
        });
        setTimeout(() => {
            this.getApplicantList();
        }, 100);
    }

    toggleInstructionDetails() {
        this.setState(prevState => ({
            isInstructionsOpen: !prevState.isInstructionsOpen
        }))
    }
    toggleQueryModal() {
        const { isQueryModal, application_form_id } = this.state;
        if (isQueryModal == false) {
            this.props.juryApplicationQuery_action(application_form_id)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ queryCoordinatorData: data.data[0], queryLogData: data.data[1] })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
        this.setState(prevState => ({
            isQueryModal: !prevState.isQueryModal
        }))
    }

    handleTimeChange = (e) => {
        const value = e.target.value; // 'HH:mm' format
        const [hour, minute] = value.split(':').map(Number);

        let newTime = '';
        if (minute < 15) {
            newTime = `${hour.toString().padStart(2, '0')}:00`;
        } else if (minute < 30) {
            newTime = `${hour.toString().padStart(2, '0')}:15`;
        } else if (minute < 45) {
            newTime = `${hour.toString().padStart(2, '0')}:30`;
        } else {
            newTime = `${hour.toString().padStart(2, '0')}:45`;
        }

        this.setState({ callback_time: newTime });
    };
    submitQuery() {
        const { jury_application_form_query_id, application_form_id, qry_ans_by_id, qry_answer, qry_ans_date, callback_query, callback_date, callback_time } = this.state
        if (callback_query == '', callback_date, callback_time) {
            toastError('Kindly Enter Query')
        } else if (callback_date == '') {
            toastError('Kindly Select Callback Date')
        } else if (callback_time == '') {
            toastError('Kindly Select Callback Time')
        } else {
            const isConfirm = window.confirm('Are you sure you want to submit this Query?')
            if (isConfirm) {
                this.setState({ isLoading: true })
                this.props.insertUpdateJuryQuery_action(jury_application_form_query_id, application_form_id, qry_ans_by_id, qry_answer, qry_ans_date, callback_query, callback_date, callback_time)
                    .then((data) => {
                        this.setState({ isLoading: false })
                        if (data.error != 1) {
                            toastSuccess("Query Submitted Successfully");
                            this.setState({ callback_query: '', callback_date: '', callback_time: '', isQueryModal: false })
                        } else {
                            responseError(data)
                        }
                    }).catch((e) => {
                        console.log(e);
                        this.setState({ isLoading: false });
                    })
            }
        }
    }
    //submit scoring pattern
    getJuryReviewScoringPattern = (award_event_profile_id, application_form_id) => {
        this.setState({ isLoading: true });
        this.props.juryReviewScoringPattern_action(award_event_profile_id, application_form_id)
            .then((data) => {
                if (data.error !== 1) {
                    const AddScoringData = data.data[0].map(field => ({
                        applicant_scoring_id: null,
                        application_form_id: application_form_id,
                        award_event_id: parseInt(award_event_id),
                        award_event_profile_id: field.award_event_profile_id,
                        scoring_pattern_id: field.award_event_profile_scoring_pattern_id,
                        section_id: field.section_fields_id,
                        score: field.calculated_score ? field.scoring_mode_id == 1
                            ? parseFloat(parseFloat(field.calculated_score).toFixed(1))
                            : null : null,
                        max_score: field.max_score,
                    }))
                    this.setState({
                        scoringFields: data.data[0],
                        scoringData: data.data[1].length > 0 ? data.data[1] : AddScoringData,
                        application_status_id: data.data[2][0].application_status_id,
                        milestoneStartDate: data.data[2][0].milestoneStartDate,
                        milestoneEndDate: data.data[2][0].milestoneEndDate,
                        isLoading: false,
                    });
                } else {
                    this.setState({ isLoading: false });
                    responseError(data);
                }
            })
            .catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    handleScoreChange = (sectionId, value, max_score) => {
        if (isNaN(value)) {
            return; // Prevent invalid values
        }
        if (value > max_score) {
            toastError('Score should not be greater than Max Score');
            return;
        }
        if (value < 0) {
            toastError('Score cannot be negative');
            return;
        }
        this.setState(prevState => ({
            scoringData: prevState.scoringData.map(data =>
                data.section_id === sectionId
                    ? { ...data, score: value }
                    : data,
            ),
        }));
    };

    calculateTotalScore = () => {
        const { scoringData } = this.state;
        return scoringData.reduce((total, item) => {
            const score = parseFloat(item.score) || 0;
            return total + score;
        }, 0);
    };
    toggleReviewModal = (type) => {
        const { reviewSubmitModal } = this.state
        if (reviewSubmitModal) {
            this.setState({
                reviewSubmitModal: false,
                reviewModalTitle: '',
                reviewModalContent: '',
                reviewModalContent2: '',
                reviewType: ''
            });
        } else {
            this.setState({
                reviewSubmitModal: true,
                reviewModalTitle: type == 6 ? 'Save As Draft' : type == 7 ? 'Submit Review' : null,
                reviewModalContent: type == 6 ? 'Do you really want to save this Application Form as Draft ?' : type == 7 ? 'Do you really want to Submit the Review for this Application Form ?' : null,
                reviewModalContent2: type == 6 ? 'This will allow you to change the scoring and can submit the remaining scoring later for this Application Form.' :
                    type == 7 ? 'This will Submit the Review for this Application Form and cannot be update or change once the Application Form is submitted.' : null,
                reviewType: type
            });
        }
    }

    handleSubmit = async (application_status_id) => {
        const { scoringData, scoringFields } = this.state;
        const updatedScoringData = [];
        const award_event_profile_id = scoringData.length > 0 ? scoringData[0].award_event_profile_id : null;

        for (const data of scoringData) {
            const matchingField = scoringFields.find(
                (field) => field.section_fields_id === data.section_id
            );
            if (application_status_id == 7) {
                if (data.score === null || data.score === '' || data.score === undefined) {
                    toastError("Score cannot be empty, Enter 0 if not applicable");
                    return;
                }
            }
            updatedScoringData.push({
                ...data,
                award_event_id: sessionStorage.getItem('award_event_id'),
                score: data.score === null ? 0 : data.score,
                calculate_value: matchingField ? data.score * matchingField.factor_value : undefined,
            });
        }
        this.setState({ isLoading: true });

        try {
            const response = await this.props.insertUpdateJuryReviewScoring_action(
                application_status_id, sessionStorage.getItem('jury_id'),
                award_event_profile_id,
                updatedScoringData
            );
            if (response.error !== 1) {
                toastSuccess("Review Submitted Successfully");
                this.setState({ isLoading: false, reviewSubmitModal: false, reviewType: null, reviewModalTitle: "", reviewModalContent: '', reviewModalContent2: '' });
                window.location.reload();
            } else {
                responseError(response);
            }
        } catch (error) {
            console.error("Submission error:", error);
            this.setState({ isLoading: false });
        }

    };

    highlightField(section_fields_id) {
        const sectionElement = document.getElementById(`section-${section_fields_id}`);
        if (sectionElement) {
            sectionElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        this.setState({
            selectedSectionFieldId: section_fields_id,
            scoringfieldSelected: true,
        });
    }

    render() {
        const {
            isLoading, isAccordionExpanded, applicantList, juryReviewEndDate,
            eligibility_criteria, screening_process, theme, important_instructions, applicationFormList,
            award_name, DeclarationFileName, queryCoordinatorData, questionQuerydata, queryPostContent, isCollapse,
            scoringData, scoringFields, sme_certificate_FileName, download_SME_Certificate_file_path, applicantTypeID, countryId, stateName, cityName, pinCode
            , applicantTypeList, countryList, applicantTypeName, category_names, juryDateEnded,
            round_id, round_name, award_event_profile_id, status_name, isReplyMode, question_id,
            roundFillList, awardProfileFillList, applicationStatusFillList, jury_application_status_id,
            selectedSectionFieldId, scoringfieldSelected, application_no, download_Declaration_file_path,
            reviewSubmitModal, reviewType, reviewModalTitle, reviewModalContent, reviewModalContent2, applicationStatusMultiFillList, applicationStatusMultiSelected
        } = this.state;
        return (
            <>
                {isLoading ? <Loader></Loader> : null}
                <>
                    <main id="main">

                        <div className="website-view">
                            <Header data={[8]} />
                        </div>
                        <div className="mobile-view">
                            <MobileHeader data={[8]} />
                        </div>
                        {/* <Header data={[20]} /> */}
                        <section class='header_margin_top'>
                            <div className="container-fluid" style={{ background: '#FCFCFC' }}>
                                <div className="search_accordion">
                                    <div className="panel-group" id="accordion">
                                        <div className="panel panel-default">
                                            <div
                                                className="panel-heading accordion-toggle collapsed p-2"
                                                data-toggle="collapse"
                                                data-parent="#accordion"
                                                data-target="#collapseOne"
                                                aria-expanded={isAccordionExpanded}
                                                onClick={() =>
                                                    this.setState({
                                                        isAccordionExpanded: !isAccordionExpanded,
                                                    })
                                                }
                                            >
                                                <h4 className="panel-title">Search</h4>
                                                <div className="searched_items">
                                                    {round_id ? <><h5><b> Round :</b> <span>{round_id != "" ? round_name : null}</span></h5></> : <></>}
                                                    {award_event_profile_id ? <h5><b> Category :</b> <span>{award_event_profile_id != "" ? award_name : null}</span></h5> : <></>}
                                                    {jury_application_status_id ? <h5><b> Status :</b> <span>{jury_application_status_id != "" ? status_name : null}</span></h5> : <></>}
                                                </div>
                                            </div>
                                            <div
                                                id="collapseOne"
                                                className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                                    }`}
                                            >
                                                <div className="panel-body">
                                                    <div className="row mr_0">
                                                        <div className="col-md-2 ml-2">
                                                            <div className="form-group">
                                                                <label>Round</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={round_id}
                                                                    onChange={(e) => {
                                                                        const selectedRound = roundFillList.find((item) => item.round_id === parseInt(e.target.value, 10));
                                                                        this.setState({
                                                                            round_id: selectedRound?.round_id,
                                                                            round_name: selectedRound?.round_name,
                                                                        })
                                                                    }}>
                                                                    <option value="">Select</option>
                                                                    {roundFillList.length > 0 &&
                                                                        roundFillList.map((item) => (
                                                                            <option key={item.round_id} value={item.round_id}>
                                                                                {item.round_name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label>Category</label>
                                                                <select
                                                                    className="form-select"
                                                                    value={award_event_profile_id}
                                                                    onChange={(e) => {
                                                                        const selectedCategory = awardProfileFillList.find(
                                                                            (item) => item.award_event_profile_id === parseInt(e.target.value, 10)
                                                                        );
                                                                        this.setState({
                                                                            award_event_profile_id: selectedCategory?.award_event_profile_id,
                                                                            award_name: selectedCategory?.award_name,
                                                                        });
                                                                    }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {awardProfileFillList.length > 0 &&
                                                                        awardProfileFillList.map((item) => (
                                                                            <option key={item.award_event_profile_id} value={item.award_event_profile_id}>
                                                                                {item.award_name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label>Status</label>
                                                                <Select
                                                                    isMulti
                                                                    value={applicationStatusMultiSelected}
                                                                    options={applicationStatusMultiFillList}
                                                                    styles={customStyles}
                                                                    onChange={(selectedOptions) => {
                                                                        const selectedIds = selectedOptions.map(option => option.value).join(", ");
                                                                        const selectedNames = selectedOptions.map(option => option.label).join(", ");

                                                                        this.setState({
                                                                            applicationStatusMultiSelected: selectedOptions,
                                                                            jury_application_status_id: selectedIds, // Comma-separated application_status_id
                                                                            status_name: selectedNames, // Comma-separated status_name
                                                                        });
                                                                    }}
                                                                />


                                                                {/* <select
                                                                    className="form-select"
                                                                    value={jury_application_status_id}
                                                                    onChange={(e) => {
                                                                        const selectedStatus = applicationStatusFillList.find(
                                                                            (item) => item.application_status_id === parseInt(e.target.value, 10)
                                                                        );
                                                                        this.setState({
                                                                            jury_application_status_id: selectedStatus?.application_status_id,
                                                                            status_name: selectedStatus?.status_name,
                                                                        });
                                                                    }}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {applicationStatusFillList.length > 0 &&
                                                                        applicationStatusFillList.map((item) => (
                                                                            <option key={item.application_status_id} value={item.application_status_id}>
                                                                                {item.status_name}
                                                                            </option>
                                                                        ))}
                                                                </select> */}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label>&nbsp;</label>
                                                            <button
                                                                onClick={() => this.getApplicantList()}
                                                                className="btn btn-outline-primary mr-2"
                                                            >
                                                                Search
                                                            </button>
                                                            &nbsp;
                                                            <button
                                                                onClick={this.clearFilters}
                                                                className="btn btn-outline-danger"
                                                            >
                                                                Clear Filters
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ">
                                    <div className="col-md-2 col-12">
                                        <div className="apply-application border">
                                            <p className="application-title-header">Application Name</p>
                                            {applicantList?.length > 0 ? (
                                                applicantList.map((data, index) => (
                                                    <div
                                                        className="application-card"
                                                        key={index}
                                                        onClick={() => this.selectApplicationView(data.award_event_profile_id, data.application_form_id, index, data.application_status_id, data.juryReviewEndDate)}
                                                        style={{ backgroundColor: this.state.selectedIndex === index ? 'rgb(255 233 210)' : 'white' }}
                                                    >
                                                        <p className="application-title mb-0">{data.application_no}</p>
                                                        {/* <p className="company-name">companyName</p> */}
                                                        <p style={{ marginBottom: '0px' }} className={data.application_status_id === 7 ? 'text-success' : data.application_status_id === 6 ? 'text-warning' : data.application_status_id === 5 ? 'text-danger' : ''}>
                                                            {data.application_status_id === 5 ? "Not Reviewed" : data.application_status_id === 6 ? "Partial Reviewed" : data.application_status_id === 7 ? "Reviewed" : ""}
                                                        </p>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="application-card">
                                                    <p className="application-title">No Application Found</p>
                                                    <p className="company-name"></p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-12 ">
                                        {juryDateEnded && (
                                            <div class="orange_strip" style={{
                                                padding: '11px 15px',
                                                background: 'rgb(103 178 180)',
                                                lineHeight: '1',
                                                color: '#fff',
                                                fontWeight: '600',
                                                textAlign: 'center',
                                                marginBottom: '10px',
                                                position: 'relative',
                                            }}>Jury Review Ended on {juryReviewEndDate}</div>
                                        )}
                                        <div class="page-header row mb-4">
                                            <h4 class="page-title  mb-3">
                                                <span className="mb-2" style={{ fontSize: '19px', color: '#f1c841', }}>Application No: {application_no} </span>
                                            </h4>
                                            {applicationFormList.length > 0 ? <>
                                                <div class="d-flex" style={{ marginTop: '5px', justifyContent: 'space-between' }}>
                                                    <h4 class="page-title">  Award Category: {award_name ? award_name : ''}</h4>
                                                    <div className="d-flex both-btn-jury">
                                                        <a
                                                            className="btn btn-danger btn-sm create_btn add_additional_days_btn  d-flex align-items-center ml-2"
                                                            style={{ width: "min-content", height: '31px' }}
                                                        >
                                                            <i className="ri-information-line "></i>  <Link
                                                                to="query"
                                                                class="nav-link"
                                                                style={{ cursor: "pointer", color: 'white' }}
                                                                smooth={true}
                                                                duration={500}
                                                                offset={-100}
                                                            >
                                                                Query
                                                            </Link>
                                                        </a>
                                                        {jury_application_status_id != '' && <span class="status draft ml-2">{(() => {
                                                            const formStatus = applicationStatusFillList?.find(
                                                                (item) => item.application_status_id == jury_application_status_id);
                                                            return formStatus ? `${formStatus.status_name}` : "";
                                                        })()} </span>}
                                                    </div>
                                                </div>
                                            </> : null}
                                            <h4 class="page-title w-100 col-10">
                                                {applicationFormList.length > 0 ? <>
                                                </> : "No Application Selected"}
                                            </h4>

                                        </div>
                                        <div class="card-body">
                                            <div className="company_info">
                                                {applicationFormList.length > 0 && (
                                                    <fieldset>
                                                        <div
                                                            className="panel-heading accordion-toggle collapsed "
                                                            data-toggle="collapse"
                                                            data-parent="#accordion"
                                                            data-target="#collapseOne"
                                                            aria-expanded={isCollapse}
                                                            onClick={() =>
                                                                this.setState({
                                                                    isCollapse: !isCollapse,
                                                                })
                                                            }
                                                        >
                                                            <legend class="panel-title"><i style={{ verticalAlign: 'middle' }} class="ri-information-line "></i><span style={{ cursor: 'pointer', fontSize: '16px' }} >Instructions</span> <span style={{ marginLeft: '6px' }}>(<a style={{ fontSize: '14px', textDecoration: 'underline', color: '#007bffe8' }}>{isCollapse ? ' Show Less ' : ' Show More '}</a></span>)</legend>
                                                        </div>

                                                        <div class="panel-group" id="accordion">
                                                            <div class="panel panel-default">
                                                                <div
                                                                    id="collapseOne"
                                                                    className={`panel-collapse p-0 collapse ${isCollapse ? "show" : ""
                                                                        }`}
                                                                >
                                                                    <div class="panel-body" style={{ padding: '5px 10px' }}>
                                                                        <div class="form-group" style={{ marginTop: '35px' }}>
                                                                            <div class="row">
                                                                                <div class="col-md-12">
                                                                                    <div className="awards-row" style={{ borderTop: '1px solid #e0e0e0' }}>
                                                                                        <div className="label">Category</div>
                                                                                        <div className="content">
                                                                                            {category_names}
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="awards-row">
                                                                                        <div className="label">Theme</div>
                                                                                        <div className="content">
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: purify.sanitize(theme)
                                                                                            }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>

                                                                                    <div className="awards-row">
                                                                                        <div className="label">Eligibility</div>
                                                                                        <div className="content">
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: purify.sanitize(eligibility_criteria)
                                                                                            }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="awards-row">
                                                                                        <div className="label">Screening Process</div>
                                                                                        <div className="content">
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: purify.sanitize(screening_process)
                                                                                            }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="awards-row">
                                                                                        <div className="label">Important Instructions</div>
                                                                                        <div className="content">
                                                                                            <div dangerouslySetInnerHTML={{
                                                                                                __html: purify.sanitize(important_instructions)
                                                                                            }}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </fieldset>
                                                )}
                                                {applicationFormList.length > 0 ? applicationFormList.map((data, index) => (
                                                    <>
                                                        <fieldset key={index}>
                                                            <legend>{data.section_name}</legend>
                                                            <div className="outside_input_field ">
                                                                <div class="row" style={{ marginTop: '25px' }}>
                                                                    {data.array.length > 0 && data.array.map((item, i) => (
                                                                        <>
                                                                            {
                                                                                (index == 0 && i == 0) &&
                                                                                <>
                                                                                    <div className="col-4 mb-2">
                                                                                        <label style={{ fontWeight: '600' }}>Applicant Type<span className="mendatory_class">*</span></label>
                                                                                        <p className="query-text" >{(() => {
                                                                                            const applicantTypeName = applicantTypeList.find((item) =>
                                                                                                item.applicant_type_id === applicantTypeID);
                                                                                            return applicantTypeName ? `${applicantTypeName.applicant_name}` : "";
                                                                                        })()}</p>
                                                                                    </div>
                                                                                    {/* {applicantTypeName.toLowerCase() == 'MSME' &&
                                                                                        <div class="col-md-4">
                                                                                            <div class="form-group">
                                                                                                <label style={{ fontWeight: '600' }}>
                                                                                                    MSME Certificate<span className="mendatory_class">*</span>
                                                                                                </label>
                                                                                                {sme_certificate_FileName == '' ?
                                                                                                    <div class="form-group mt-1" >
                                                                                                        <input type="file" name="files[]" multiple
                                                                                                            disabled={true} class="custom-file-input form-control"
                                                                                                            id="customFile"
                                                                                                        // onChange={(e) => this.onSME_CertificateFilePick(e, e.target.files)}
                                                                                                        />
                                                                                                        <label class="custom-file-label" for="customFile" style={{ fontWeight: '600' }}>Upload Declaration Form</label>
                                                                                                    </div> :
                                                                                                    <div className='membership_file' >
                                                                                                        {download_SME_Certificate_file_path != null && download_SME_Certificate_file_path != '' ?
                                                                                                            <span className='overflow-membership'><a
                                                                                                                href={BASE_URL.split('/api')[0] + download_SME_Certificate_file_path}
                                                                                                                target='blank' style={{ textDecoration: 'none', color: '#414244' }}>{sme_certificate_FileName}</a></span> :
                                                                                                            <span className='overflow-membership'>{sme_certificate_FileName}</span>
                                                                                                        }

                                                                                                    </div>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    } */}
                                                                                    <div class="col-md-4">
                                                                                        <label style={{ fontWeight: '600' }}>Country<span className="mendatory_class">*</span></label>
                                                                                        <p className="query-text" >{(() => {
                                                                                            const countryName = countryList.find((item) =>
                                                                                                item.country_id === countryId);
                                                                                            return countryName ? `${countryName.CountryName}` : "";
                                                                                        })()}</p>
                                                                                    </div>
                                                                                    <div class="col-md-4">
                                                                                        <label style={{ fontWeight: '600' }}>State<span className="mendatory_class">*</span></label>
                                                                                        <p className="query-text" >
                                                                                            {stateName}</p>

                                                                                    </div>
                                                                                    <div class="col-md-4">
                                                                                        <label style={{ fontWeight: '600' }}>City<span className="mendatory_class">*</span></label>
                                                                                        <p className="query-text" >
                                                                                            {cityName}</p>
                                                                                    </div>
                                                                                    <div class="col-md-4">
                                                                                        <label style={{ fontWeight: '600' }}> {
                                                                                            countryId == '91' || countryId == '' ? 'Pincode' : 'ZipCode'
                                                                                        }<span className="mendatory_class">*</span></label>
                                                                                        <p className="query-text" >
                                                                                            {pinCode}</p>
                                                                                    </div>
                                                                                </>
                                                                            }
                                                                            {(item.controltype_Name == 'Text Box - Numeric' || item.controltype_Name == 'Text Box - AlphaNumeric' || item.controltype_Name == 'Text Box - Email' ||
                                                                                item.controltype_Name == 'Text Box - Phone Number' || item.controltype_Name == 'Text Box - Website' || item.controltype_Name == 'Multiline Text Box' || item.controltype_Name == 'Text Box - Decimal') &&
                                                                                <div class="col-md-12 mt-2" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                    <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                        <label style={{ fontWeight: '600' }}>
                                                                                            {item.fieldname}{item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                        </label>
                                                                                        <p className="query-text" >
                                                                                            {item.applicant_response}</p>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {(item.controltype_Name == 'Date Picker') &&
                                                                                <div class="col-md-12" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                    <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                        <label style={{ fontWeight: '600' }}>
                                                                                            {item.fieldname}
                                                                                            {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                        </label>
                                                                                        <p className="query-text" >
                                                                                            {moment(item.applicant_response).format('DD-MMM-YYYY')}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {(item.controltype_Name == 'Dropdown - Single-Select') &&
                                                                                <div class="col-md-12" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                    <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                        <label style={{ fontWeight: '600' }}>
                                                                                            {item.fieldname}
                                                                                            {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                        </label>
                                                                                        <select
                                                                                            class="form-select"
                                                                                            disabled={true}
                                                                                            value={item.applicant_response}
                                                                                        >
                                                                                            <option>Select</option>
                                                                                            {item.optionData != undefined && item.optionData.length > 0 &&
                                                                                                item.optionData.map((option) => (
                                                                                                    <option
                                                                                                        key={option.options}
                                                                                                        value={option.options}
                                                                                                    >
                                                                                                        {option.options}
                                                                                                    </option>
                                                                                                ))}
                                                                                        </select>

                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {(item.controltype_Name == 'Dropdown - Multi-Select') &&
                                                                                <div class="col-md-12" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                    <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                        <label style={{ fontWeight: '600' }}>
                                                                                            {item.fieldname}
                                                                                            {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                        </label>
                                                                                        <Select
                                                                                            isMulti
                                                                                            isDisabled={true}
                                                                                            styles={customStyles}
                                                                                            value={item.Multi_Select_value}
                                                                                            options={item.optionData}
                                                                                        />

                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {(item.controltype_Name == 'Checkbox - Single-Select') &&
                                                                                <div class="col-md-122" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                    <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                        <>
                                                                                            <label style={{ fontWeight: '600' }}>
                                                                                                {item.fieldname}
                                                                                                {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                            </label>
                                                                                            <div className="bg only_checkbox d-flex flex-row" style={{ flexWrap: 'wrap' }}>
                                                                                                {item.optionData.length > 0 && item.optionData.map((option, objIndex) => (
                                                                                                    <div className="" >
                                                                                                        <label
                                                                                                            className="lebel-dis d-flex"
                                                                                                            htmlFor={`ServiceCheck-${objIndex}-${item.fieldname}`}
                                                                                                            style={{ color: "#979797", marginLeft: '12px' }}
                                                                                                        >
                                                                                                            <input type="checkbox" className="mr-2"
                                                                                                                disabled={true}
                                                                                                                checked={option.isChecked}
                                                                                                                id={`ServiceCheck-${objIndex}-${item.fieldname}`} />
                                                                                                            {option.options}
                                                                                                        </label>
                                                                                                        <span></span>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        </>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {(item.controltype_Name == 'Checkbox - Multi-Select') &&
                                                                                <div class="col-md-122" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                    <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                        <>
                                                                                            <label style={{ fontWeight: '600' }}>
                                                                                                {item.fieldname}
                                                                                                {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                            </label>
                                                                                            <div className="bg only_checkbox d-flex flex-row" style={{ flexWrap: 'wrap' }}>
                                                                                                {item.optionData != undefined && item.optionData.length > 0 && item.optionData.map((option, index) => (
                                                                                                    <div className="" key={index}>

                                                                                                        <label
                                                                                                            className="lebel-dis d-flex"
                                                                                                            htmlFor={`ServiceMultiCheck-${index}-${item.fieldname}`}
                                                                                                            style={{ color: "#979797", marginLeft: '12px' }}
                                                                                                        >
                                                                                                            <input type="checkbox" className="mr-2"
                                                                                                                disabled={true}
                                                                                                                checked={option.isChecked}
                                                                                                                id={`ServiceMultiCheck-${index}-${item.fieldname}`} />
                                                                                                            {option.options}
                                                                                                        </label>
                                                                                                        <span></span>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>

                                                                                        </>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                            {(item.controltype_Name == 'File Upload') &&
                                                                                <div class="col-md-12" style={(scoringfieldSelected && selectedSectionFieldId === item.award_event_profile_section_fields_id) ? { background: 'rgb(255 233 210)', padding: '10px' } : null}>
                                                                                    <div class="form-group" id={`section-${item.award_event_profile_section_fields_id}`} key={item.award_event_profile_section_fields_id}>
                                                                                        <label style={{ fontWeight: '600' }}>
                                                                                            {item.fieldname}
                                                                                            {item.is_mandatory && <span className="mendatory_class">*</span>}
                                                                                        </label>

                                                                                        <div className='membership_file' >
                                                                                            <span className='overflow-membership' > <a href={BASE_URL.split('/api')[0] + '/' + (item.file_path != null && item.file_path.split('./')[1])} title={item.FileName}
                                                                                                target='blank'> {item.FileName}</a></span>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </>
                                                                    ))}
                                                                </div >
                                                            </div>
                                                        </fieldset >
                                                    </>
                                                )) : <></>}
                                                {applicationFormList.length > 0 ? <>
                                                    <fieldset className="pb-6">
                                                        <legend> Declaration</legend>
                                                        <a href={BASE_URL.split('/api')[0] + download_Declaration_file_path} title={DeclarationFileName}
                                                            target='_blank'><button type="button" style={{ float: 'right' }} class="mt-4 btn btn-outline-success view-btn">
                                                                <i class="ri-external-link-line"></i>{" "}View Declaration
                                                            </button></a>
                                                    </fieldset>
                                                </> : <>
                                                </>}
                                            </div>
                                        </div>
                                    </div>
                                    {applicationFormList.length > 0 ? <>
                                        <div className="col-md-3 col-12">
                                            <div className="apply-application border">
                                                <p className="application-title-header">Score</p>
                                                {scoringFields.length > 0 ? (
                                                    scoringFields.map((data, index) => (
                                                        <div
                                                            key={index}
                                                            className="application-card"
                                                            onClick={() => this.highlightField(data.section_fields_id)}
                                                            style={
                                                                scoringfieldSelected && selectedSectionFieldId === data.section_fields_id
                                                                    ? { background: 'rgb(255 233 210)', padding: '10px' }
                                                                    : null
                                                            }
                                                        >
                                                            <p className="application-title">{data.marking_pattern_name} {''} {data.description ? <i class="ri-information-line" title={data.description}></i> : <></>}</p>
                                                            {data.suvinContent ? <>
                                                                <div className="reply-box mb-5">
                                                                    {this.state.expandedField === data.section_fields_id ? (
                                                                        <>
                                                                            <div>
                                                                                {data.suvinContent}
                                                                                <span
                                                                                    style={{ color: 'blue', cursor: 'pointer', marginLeft: '5px' }}
                                                                                    onClick={() => this.setState({ expandedField: null })}
                                                                                >
                                                                                    Show Less
                                                                                </span>
                                                                            </div>

                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <div
                                                                                style={{
                                                                                    overflow: 'hidden',
                                                                                    display: '-webkit-box',
                                                                                    WebkitBoxOrient: 'vertical',
                                                                                    WebkitLineClamp: 2,
                                                                                }}
                                                                            >
                                                                                {data.suvinContent}
                                                                            </div>
                                                                            {data.suvinContent && data.suvinContent.length > 50 && (
                                                                                <span
                                                                                    style={{ color: 'blue', cursor: 'pointer', marginTop: '5px', display: 'inline-block' }}
                                                                                    onClick={() => this.setState({ expandedField: data.section_fields_id })}
                                                                                >
                                                                                    Show More
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </> : <></>}
                                                            <p className="company-name">
                                                                {console.log('scoringData.find(item => item.section_id === data.section_fields_id)', scoringData.find(item => item.section_id == data.section_fields_id))}
                                                                <input
                                                                    type="text"
                                                                    disabled={data.scoring_mode_id === 1 || jury_application_status_id == 7 || juryDateEnded}
                                                                    className="score-box"
                                                                    style={
                                                                        (data.scoring_mode_id === 1 || jury_application_status_id == 7 || juryDateEnded)
                                                                            ? { background: '#e9ecef', width: '50px' }
                                                                            : { width: '50px' }
                                                                    }
                                                                    value={
                                                                        scoringData.find(item => item.section_id === data.section_fields_id)?.score
                                                                    }
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const numericValue = value
                                                                            .replace(/[^0-9.]/g, "")
                                                                            .replace(/(\..*)\./g, "$1");
                                                                        this.handleScoreChange(
                                                                            data.section_fields_id,
                                                                            numericValue,
                                                                            data.max_score
                                                                        );
                                                                    }}
                                                                />
                                                                {" "}
                                                                / {data.max_score}
                                                            </p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <></>
                                                )}
                                                {scoringFields.length > 0 && (
                                                    <>
                                                        <div className="application-card">
                                                            <p className="application-title">Total</p>
                                                            <p className="company-name">
                                                                {this.calculateTotalScore() || 0}
                                                                /{" "}
                                                                {scoringFields.reduce((total, field) => total + field.max_score, 0)}
                                                            </p>
                                                        </div>
                                                        <div className="row">
                                                            {jury_application_status_id == 7 ? (
                                                                <>
                                                                    <button className="btn btn-outline-primary btn-sm col-5 ml-4" disabled>
                                                                        Reviewed
                                                                    </button>
                                                                </>
                                                            ) : juryDateEnded ? (
                                                                <>
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm col-5 ml-2 mr-2"
                                                                        disabled
                                                                    >
                                                                        Save as Draft
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm col-5"
                                                                        disabled
                                                                    >
                                                                        Submit Review
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm col-5 ml-2 mr-2"
                                                                        // onClick={() => this.handleSubmit(6)}
                                                                        onClick={() => this.toggleReviewModal(6)}
                                                                    >
                                                                        Save as Draft
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-outline-primary btn-sm col-5"
                                                                        // onClick={() => this.handleSubmit(7)}
                                                                        onClick={() => this.toggleReviewModal(7)}
                                                                    >
                                                                        Submit Review
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </> : <></>}
                                </div>

                            </div>
                        </section>
                        {applicationFormList.length > 0 ? <>
                            <div className="card-body m-4">
                                <div className="company_info">
                                    <Element name="query" className="element">
                                        <fieldset>
                                            <legend>Query</legend>
                                            <div className="outside_input_field">
                                                <div className="query-container">
                                                    {console.log('questionQuerydata222', questionQuerydata)}
                                                    {questionQuerydata.length > 0 ? questionQuerydata.map((data) => (
                                                        <>
                                                            <div className="query">
                                                                <div className="user-icon ps">{data.question_author
                                                                    .split(" ").map((word) => word[0])
                                                                    .join("").toUpperCase()}</div>
                                                                <div className="query-content">
                                                                    <div className="query-header row">
                                                                        <div className="col-10">
                                                                            <span className="user-name">{data.question_author}</span>
                                                                            <span className="timestamp px-2">
                                                                                {data.question_time} | {moment(data.question_date).format('DD-MMM-YYYY')}
                                                                            </span>
                                                                        </div>
                                                                        {data.created_by_id === parseInt(sessionStorage.getItem('user_id')) ? <></> : <>
                                                                            <div className="col-1 text-right">
                                                                                <i class={(isReplyMode && (question_id === data.question_id)) ? "ri-close-line querycancel" : 'ri-reply-line'} onClick={() => this.onReplyToggle(data.question_id)}></i>
                                                                            </div>
                                                                        </>}
                                                                    </div>
                                                                    <p className="query-text" >
                                                                        {data.title}
                                                                    </p>
                                                                </div>
                                                                {data?.answerQueryData?.length > 0 && data?.answerQueryData?.map((answer) => (
                                                                    <div className="query" style={{ marginLeft: '50px' }}>
                                                                        <div className="user-icon ps">{answer.answer_author
                                                                            .split(" ").map((word) => word[0])
                                                                            .join("").toUpperCase()}</div>
                                                                        <div className="query-content">
                                                                            <div className="query-header row">
                                                                                <div className="col-10">
                                                                                    <span className="user-name">{answer.answer_author}</span>
                                                                                    <span className="timestamp px-2">
                                                                                        {answer.answer_time} | {moment(answer.answer_date).format('DD-MMM-YYYY')}
                                                                                    </span>
                                                                                </div>
                                                                                {/* <div className="col-1">
                                                                                                                                                <button className="send-button" onClick={() => this.onReplyToggle()}><i class="ri-reply-line" style={{ fontSize: '24px' }}></i></button>
                                                                                                                                            </div> */}
                                                                            </div>
                                                                            <p className="query-text">
                                                                                <div dangerouslySetInnerHTML={{
                                                                                    __html: purify.sanitize(answer.answer_content)
                                                                                }}
                                                                                />
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            {isReplyMode && (question_id === data.question_id) ? (<>
                                                                <div className="reply-box mb-5">
                                                                    <div className="user-icon vs replay-cir"> {sessionStorage.getItem("user_name") &&
                                                                        sessionStorage
                                                                            .getItem("user_name")
                                                                            .split(" ")
                                                                            .map((word) => word[0])
                                                                            .join("")
                                                                            .toUpperCase()}</div>
                                                                    <textarea rows={2} value={queryPostContent} maxLength={500} class="reply-input rounded-0" placeholder="reply to the query" onChange={(e) => this.setState({ queryPostContent: e.target.value })}></textarea>
                                                                    <button className="send-button" onClick={() => this.replyQuery(data.question_id)}><i class="ri-send-plane-2-line"></i></button>
                                                                </div>
                                                            </>
                                                            ) : <></>}
                                                        </>
                                                    )) : (
                                                        <>
                                                            <div className="query">
                                                                <div className="query-content">
                                                                    <p className="query-text text-center">
                                                                        No Query Yet!... Start a conversation.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                    {isReplyMode ? <></> : <>
                                                        <div className="reply-box mb-5">
                                                            <div className="user-icon vs replay-cir"> {sessionStorage.getItem("user_name") &&
                                                                sessionStorage
                                                                    .getItem("user_name")
                                                                    .split(" ")
                                                                    .map((word) => word[0])
                                                                    .join("")
                                                                    .toUpperCase()}</div>
                                                            <textarea rows={2} type="text" placeholder="Post a Query" maxLength={500} className="reply-input rounded-0" onChange={(e) => this.setState({ queryPostContent: e.target.value })}></textarea>
                                                            <button className="send-button" onClick={() => this.postQuery()}><i class="ri-send-plane-2-line"></i></button>
                                                        </div>
                                                    </>}

                                                    <div className="mt-4">
                                                        <div className="containerr">
                                                            <div className="title">Call Back</div>

                                                            <div className="row m-4 mb-2 mt-1 bg-light p-4 border rounded-1">
                                                                {/* Date Input */}
                                                                <div className="col-md-3 form-group mb-0">
                                                                    <input
                                                                        type="date"
                                                                        className="form-control border-input"
                                                                        onChange={(e) => this.setState({ callbackDate: e.target.value })}
                                                                        value={this.state.callbackDate || ""}
                                                                    />
                                                                </div>

                                                                {/* Time Input */}
                                                                <div className="col-md-3 form-group mb-0">
                                                                    <input
                                                                        type="time"
                                                                        className="form-control border-input"
                                                                        onChange={(e) => this.setState({ callbackTime: e.target.value })}
                                                                        value={this.state.callbackTime || ""}
                                                                    />
                                                                </div>

                                                                {/* Submit Button */}
                                                                <div className="col-md-3 form-group mb-0">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-outline-warning rounded-1"
                                                                        onClick={() => this.requestCallback()}
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="containerr" style={{ marginTop: '40px' }}>
                                                            <div class="title">Award Co-ordinators</div>
                                                            <table class="details-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Name</th>
                                                                        <th>Email</th>
                                                                        <th>Mobile</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {queryCoordinatorData.length > 0 ? queryCoordinatorData.map((data) => (
                                                                        <tr>
                                                                            <td>{data.name}</td>
                                                                            <td>{data.email_address}</td>
                                                                            <td>{data.contact_no}</td>
                                                                        </tr>
                                                                    )) : (
                                                                        <tr>
                                                                            <td colSpan={3}>No record found</td>
                                                                        </tr>

                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </fieldset>
                                        <Modal show={reviewSubmitModal}>
                                            <Modal.Header>
                                                <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                                    <h6>{reviewModalTitle} </h6>
                                                </Modal.Title>
                                                <span
                                                    onClick={() => this.toggleReviewModal(reviewType)}
                                                    style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                                                >
                                                    X
                                                </span>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <div>
                                                    <p className="mb-1 mt-1 com-font">
                                                        {reviewModalContent}
                                                    </p>
                                                    <p className="mb-1 mt-1 com-font">{reviewModalContent2}</p>
                                                </div>
                                            </Modal.Body>

                                            <Modal.Footer style={{ justifyContent: 'left' }}>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <button
                                                            onClick={() => this.handleSubmit(reviewType)}
                                                            class="btn btn-warning mr-2"
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            Yes
                                                        </button>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <button
                                                            onClick={() => this.toggleReviewModal(reviewType)}
                                                            class="btn btn-dark"
                                                            style={{ cursor: 'pointer', width: 'auto' }}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>

                                            </Modal.Footer>
                                        </Modal>
                                    </Element>
                                </div>
                            </div>
                        </> : <></>}

                    </main>
                    <Footer />
                    <ToastContainer />
                </>
            </>
        );
    }
}
const mapDispatchToProps = {
    juryReviewApplicationList_action, getApplicationFormDetails_action,
    getApplicationFormDefaultDetails_action, fill_action, juryReviewScoringPattern_action,
    juryApplicationQuery_action, insertUpdateJuryQuery_action, getAwardQuerywithAnswerComment_action,
    insertUpdateJuryReviewScoring_action, insertUpdateAwardQuery_action, insertUpdateAwardAnswer_action
};

export default withRouter(
    connect(null, mapDispatchToProps)(JuryDashboard)
);
